import Vue from 'vue'
import documentNotificationsApi from '@/modules/api/documentNotifications'

const state = Vue.observable({
  counts: {}
})

let pollTimer = null

function fetchCounts () {
  return documentNotificationsApi.getCounts().then(resp => {
    state.counts = (resp && resp.counts) || {}
  }).catch((err) => {
    console.log(err)
  })
}

// docType can be a single key ("vu20") or a comma-combined key ("vu20a,vu20")
function countForType (docType) {
  if (!docType) return 0
  return docType.split(',').reduce((sum, type) => sum + (state.counts[type.trim()] || 0), 0)
}

function countForTypes (docTypes) {
  return (docTypes || []).reduce((sum, type) => sum + countForType(type), 0)
}

function markRead (docTypes) {
  const types = [...new Set((docTypes || []).join(',').split(',').map(t => t.trim()).filter(Boolean))]
  if (types.length === 0) return Promise.resolve()
  return documentNotificationsApi.markAsRead(types).then(() => {
    return fetchCounts()
  }).catch((err) => {
    console.log(err)
  })
}

function startPolling (intervalMs = 60000) {
  fetchCounts()
  if (pollTimer) return
  pollTimer = setInterval(fetchCounts, intervalMs)
}

function stopPolling () {
  clearInterval(pollTimer)
  pollTimer = null
}

export default {
  state,
  fetchCounts,
  countForType,
  countForTypes,
  markRead,
  startPolling,
  stopPolling
}
